const API = process.env.REACT_APP_BACKEND_URL;

export const trackVentureEvent = (slug, event) => {
  fetch(`${API}/api/ventures/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ slug, event }),
    keepalive: true,
  }).catch(() => {});
};
